import React, { useState, useEffect } from "react";
import LkDeliveryTop from "./LkDeliveryTop";
import LkDeliveryCards from "./LkDeliveryCards";
import LkDeliveryTable from "./LkDeliveryTable";
import { orderStatus } from "../../../util";

const LkDelivery = (props) => {
    const [deliveryFilter1, setDeliveryFilter1] = useState(true);
    const [deliveryFilter2, setDeliveryFilter2] = useState(false);

    const deliveryFilter = (num) => {
        if (num === 1) {
            setDeliveryFilter1(true);
            setDeliveryFilter2(false);
        }
        if (num === 2) {
            setDeliveryFilter1(false);
            setDeliveryFilter2(true);
        }
    };

    const [viewBtn1, setViewBtn1] = useState(true);
    const [viewBtn2, setViewBtn2] = useState(false);

    const viewFilter = (num) => {
        if (num === 1) {
            setViewBtn1(true);
            setViewBtn2(false);
        }
        if (num === 2) {
            setViewBtn2(true);
            setViewBtn1(false);
        }
    };

 
    const filteredDeliveries = props.orderList.filter((el) => {
        let s = orderStatus(el);
        console.log(s);
        if (deliveryFilter1) {
            return s === "in_progress" || s === "done"; 
        }
        if (deliveryFilter2) {
            return s === "aborted"; 
        }
        return true; 
    });


    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setViewBtn1(true);
                setViewBtn2(false);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="w-full    p-[22px] md:pl-[30px]" style={{
            backgroundColor: '#EFF0F2'
        }}>
            <LkDeliveryTop
                deliveryFilter1={deliveryFilter1}
                deliveryFilter2={deliveryFilter2}
                deliveryFilter={deliveryFilter}
                viewFilter={viewFilter}
                viewBtn1={viewBtn1}
                viewBtn2={viewBtn2}
                activeCount={props.orderList.filter(el => ["in_progress", "done"].includes(orderStatus(el))).length}
                completedCount={props.orderList.filter(el => orderStatus(el) === "aborted").length}
                data={props.data}
            />

            {viewBtn1 ? (
                <LkDeliveryCards data={props.data} orderList={filteredDeliveries} />
            ) : (
                <LkDeliveryTable data={props.data} orderList={filteredDeliveries} />
            )}
        </div>
    );
};

export default LkDelivery;
